import { all, put, takeLatest, call } from 'redux-saga/effects'
import * as actionTypes from './action-types'
import * as actionTypesError from '../errors/action-types'
import { fetchProcurementInfo } from './api'

function* procurementSaga() {
  try {
    const response = yield call(fetchProcurementInfo)

    yield put({ type: actionTypes.PROCUREMENT_SUCCESS })
    yield put({
      type: actionTypes.SET_PROCUREMENT_INFORMATION,
      payload: response,
    })
  } catch (e) {
    yield put({ type: actionTypes.PROCUREMENT_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actionTypes.PROCUREMENT, procurementSaga)])
}
